<form class="memberForm" (ngSubmit)="memberDetailsSubmit()">
    <div class="row main-home py-0">
        <div class="col-md-9">
            <p role="heading" aria-level="1">Please enter information regarding the {{title}}</p>
        </div>
    </div>
    <div class="row main-home" role="form">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData1.controls" [formData]="memberFormPart1"
                (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData2.controls" [formData]="memberFormPart2"
                (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
            <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData3.controls" [formData]="memberFormPart3"
                (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
        </div>
    </div>
</form>